<script lang="ts">
  import { getFromObject } from '$shared/helpers/utils';

  interface Props {
    row: ObjectType<any>;
    col: ColumnType;
  }

  let { row, col }: Props = $props();

  let value = $derived(getFromObject(col.id, row) || '');
</script>

<div class="comp-msg-template-cell">
  <div class="label">
    {#each value.split('</b>').filter(Boolean) as val}
      {#each val.split('<b>') as item, i}
        {#if i == 0}
          {item}
        {:else}
          <span class="bold">{item}</span>
        {/if}
      {/each}
    {/each}
  </div>
</div>

<style>
  .comp-msg-template-cell {
    padding-top: 8px;
    padding-bottom: 8px;
    word-wrap: break-word;
  }
  .bold {
    font-weight: bold;
  }
</style>
